export default __webpack_public_path__ + "static/media/tumbler.3674a54f.webp";